export enum NotificationType {
    Success = 'success',
    Warning = 'warn',
    Error = 'error',
    Info = 'info',
}
